import * as API from '@/api';

function initialState () {
  return {};
}

const state = initialState ();

// getters
const getters = {};

// actions
const actions = {
  async delete (context, payload) {
    var response = await API.customer.delete (payload);
    return response;
  },

  async deleteAll (context, payload) {
    var response = await API.customer.deleteAll (payload);
    return response;
  },

  async getCustomerList (context, payload) {
    var response = await API.customer.getCustomerList (payload);
    return response;
  },

  async showPassword (context, payload) {
    var response = await API.customer.showPassword (payload);
    return response;
  },

  async sendVerificationsEmails (context, payload) {
    var response = await API.customer.sendVerificationsEmails (payload);
    return response;
  },

  async sendReminders (context, payload) {
    var response = await API.customer.sendReminders (payload);
    return response;
  },

  async download (context, payload) {
    var response = await API.customer.download (payload);
    return response;
  },
};

// mutations
const mutations = {
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
